import React from 'react';
import Grid from '@material-ui/core/Grid';
import styled from 'styled-components';
import Copyright from '../Copyright';
import SocialMedia from '../SocialMedia';
import { colors } from '../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../constants/text';
import { DESKTOP_FAT_GUTTER, DESKTOP_THIN_GUTTER } from '../../../../constants/layout';
import { biggerThan, breakpoints } from '../../../../core/util/styledComponents';
import PrivacyLinks from '../PrivacyLinks';
import Disclaimer from '../Disclaimer';

const StyledFooter = styled.div.withConfig({ componentId: 'sc-1italhw-0' })`
  background-color: ${colors.myRightFoot};
  color: ${colors.white};
  font-family: ${fontFamily.book};
  -webkit-font-smoothing: antialiased;
  line-height: 18px;
  font-size: ${fontSize.small};
  padding-top: 26px;
  padding-bottom: 34.5px;
  padding-right: ${DESKTOP_FAT_GUTTER}px;
  padding-left: ${DESKTOP_FAT_GUTTER}px;
  ${biggerThan.lg`
    padding-right: ${DESKTOP_THIN_GUTTER}px;
    padding-left: ${DESKTOP_THIN_GUTTER}px;
  `};
  span:last-child {
    padding-top: 6px;
  }
`;

const BottomLinksContainer = styled.div.withConfig({ componentId: 'sc-1italhw-1' })`
  max-width: ${breakpoints.lg};
  margin: 0 auto;
`;

const StyledPrivacyLinks = styled(PrivacyLinks).withConfig({ componentId: 'sc-1italhw-2' })`
  ${biggerThan.sm`
    a:not(:last-child) {
      :after {
        content: "|";
        padding-left: 5px;
        padding-right: 5px;
      }
    }
  `}
`;

type Props = {
  showSocial?: boolean;
  showHIPAAAuthorization?: boolean;
};

const Desktop = (props: Props) => {
  const { showSocial = true, showHIPAAAuthorization = true } = props;
  return (
    <StyledFooter>
      <BottomLinksContainer>
        <Disclaimer />
        <StyledPrivacyLinks showHIPAAAuthorization={showHIPAAAuthorization} />
        <Grid container>
          <Grid item md={9}>
            <Copyright />
          </Grid>

          {showSocial && (
            <Grid item md={3}>
              <SocialMedia />
            </Grid>
          )}
        </Grid>
      </BottomLinksContainer>
    </StyledFooter>
  );
};

export default Desktop;
